export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 3.33d279a8.png";